function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none;stroke:#009fe3;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Interface-Essential_View_binocular",
  transform: "translate(-206.755 -3339.489)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_330",
  transform: "translate(207.755 3340.5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "binocular"
}, /*#__PURE__*/React.createElement("path", {
  id: "Oval_197",
  d: "M229.394 3395.776a21.639 21.639 0 1 0-21.639-21.639 21.64 21.64 0 0 0 21.639 21.639z",
  className: "cls-1",
  transform: "translate(-207.755 -3294.793)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape_1532",
  d: "M250.419 3419.86v-66.719a12.623 12.623 0 0 0-24.793-3.366l-17.71 64.341",
  className: "cls-1",
  transform: "translate(-207.142 -3340.498)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Oval_198",
  d: "M242.894 3395.776a21.639 21.639 0 1 0-21.639-21.639 21.64 21.64 0 0 0 21.639 21.639z",
  className: "cls-1",
  transform: "translate(-156.338 -3294.793)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape_1533",
  d: "M221.255 3419.86v-66.719a12.623 12.623 0 0 1 24.793-3.366l17.71 64.325",
  className: "cls-1",
  transform: "translate(-156.338 -3340.498)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-path_94",
  d: "M216.755 3348h21.639v14.426h-21.639z",
  className: "cls-1",
  transform: "translate(-173.477 -3311.932)"
}))));

function SvgBinocular(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110.194,
    height: 102.993,
    viewBox: "0 0 110.194 102.993",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinocular);
export default __webpack_public_path__ + "static/media/binocular.4546ac69.svg";
export { ForwardRef as ReactComponent };